import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { SmallListCard } from 'appSrc/components/List';
import { SmallArticleCard } from 'appSrc/components/Article';
import { Icon } from 'appSrc/components/UI';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

const carouselOptions = {
    infinite: false,
    lazyLoad: 'progressive',
    swipeToSlide: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: <Icon source='custom' icon='carousel-prev' size={ 60 } />,
    nextArrow: <Icon source='custom' icon='carousel-next' size={ 60 } />,
    responsive: [
        {
            breakpoint:840,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint:480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

class SmallCardCarousel extends PureComponent {
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.largeCardCarousel } ${ this.props.className }`.trim() }>
                { content.length > 0 &&
                    <div className={ style.carouselWrapper }>
                        <div className={ style.carouselTitleBar }>
                            <h2>{ carousel.title }</h2>
                            { carousel.link_url &&
                                <Link to={ carousel.link_url }>{ carousel.link_text || 'See All' }</Link>
                            }
                        </div>
                        <Slider { ...carouselOptions }>
                            { content.map( ( item ) => {
                                if( item.type == 'list' ) {
                                    return (
                                        <div className={ style.cardWrapper } key={ 'curated-carousel-1l-' + item.listid }>
                                            <SmallListCard list={ item } />
                                        </div>
                                    );
                                } else if( item.type == 'curated_article' ) {
                                    return (
                                        <div className={ style.cardWrapper } key={ 'curated-carousel-1a-carousel-' + item.listid }>
                                            <SmallArticleCard article={ item } />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            } ) }
                        </Slider>
                    </div>
                }
            </div>
        );
    }
}
SmallCardCarousel.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
SmallCardCarousel.defaultProps = {
    className: '',
    carousel: {},
};

export default SmallCardCarousel;
